import React from 'react';
import { SmallNotificationBanner } from '@chegg-ui/notification-banner';
import { Link } from '@chegg-ui/link';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
import { NotificationWrapper } from './styled';
var NotificationBanner = function NotificationBanner(props) {
  var message = props.message,
    bannerType = props.bannerType,
    className = props.className,
    ctaLink = props.ctaLink,
    ctaText = props.ctaText;
  if (!message) return null;
  return /*#__PURE__*/React.createElement(NotificationWrapper, {
    className: className,
    "data-test": DataTestAttributes.NOTIFICATION_BANNER_WRAPPER
  }, /*#__PURE__*/React.createElement(SmallNotificationBanner, {
    id: 'SmallNotificationBanner',
    "data-test": DataTestAttributes.NOTIFICATION_BANNER,
    type: bannerType,
    message: message,
    ctaLink: ctaLink ? /*#__PURE__*/React.createElement(Link, {
      href: ctaLink
    }, ctaText) : undefined
  }));
};
export default NotificationBanner;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/NotificationBanner/NotificationBanner.js
// module id = 1509
// module chunks = 11